import {
  EAibGrid,
  ECertificateDocumentType,
  ECertificateType,
  EEecsRegistry,
  EEnergySource,
  EProductionTechnology,
  ETypeOfSupport,
} from 'types';

import {
  NecsPDHydroIcon,
  NecsPDMarineIcon,
  NecsPDNuclearIcon,
  NecsPDOtherIcon,
  NecsPDSolarIcon,
  NecsPDThermalIcon,
  NecsPDWindIcon,
  NecsSourceFossilIcon,
  NecsSourceNuclearIcon,
  NecsSourceOtherIcon,
  NecsSourceRenewableIcon,
  NecsSourceSynGasIcon,
  NecsSourceWastTempIcon,
} from 'components/Icons';

export const eecsRegistry = [EEecsRegistry.GREX_DK, EEecsRegistry.NECS];

export const AibGridMap: Record<EAibGrid, string> = {
  [EAibGrid.YES]: 'Yes',
  [EAibGrid.NO]: 'No',
};

export const CertificateDocumentTypeMap = {
  [ECertificateDocumentType.ISO]: { name: 'ISO' },
  [ECertificateDocumentType.TUV_SUD]: { name: 'TÜV SÜD' },
  [ECertificateDocumentType.TUV_RHEINLAND]: { name: 'TÜV Rheinland' },
  [ECertificateDocumentType.TUV_NORD]: { name: 'TÜV NORD' },
  [ECertificateDocumentType.OTHER]: { name: 'Other' },
};

export const TypeOfSupportMap: Record<ETypeOfSupport, string> = {
  [ETypeOfSupport.NO_SUPPORT]: 'No Support',
  [ETypeOfSupport.PRODUCTION]: 'Production',
};

export const EnergySourceTypeMap: Record<EEnergySource, { name: string; icon?: string; color?: string }> = {
  [EEnergySource.UNSPECIFIED]: {
    name: 'Unspecified',
    icon: NecsSourceOtherIcon,
    color: '#FAFBD1',
  },
  [EEnergySource.FOSSIL]: {
    name: 'Fossil',
    icon: NecsSourceFossilIcon,
    color: '#FE4E45',
  },
  [EEnergySource.GAS_SYNTHESIS]: {
    name: 'Gas Synthesis',
    icon: NecsSourceSynGasIcon,
    color: '#27DFCC',
  },
  [EEnergySource.NUCLEAR]: {
    name: 'Nuclear',
    icon: NecsSourceNuclearIcon,
    color: '#FF8A14',
  },
  [EEnergySource.RENEWABLE]: {
    name: 'Renewable',
    icon: NecsSourceRenewableIcon,
    color: '#00F77B',
  },
  [EEnergySource.WASTE_HEAT_COLD]: {
    name: 'Waste Heat',
    icon: NecsSourceWastTempIcon,
    color: '#ACABAB',
  },
};

export const TechnologyTypeMap: Record<EProductionTechnology, { name: string; icon?: string; color?: string }> = {
  [EProductionTechnology.WIND]: {
    name: 'Wind',
    icon: NecsPDWindIcon,
    color: '#3385F8',
  },
  [EProductionTechnology.HYDRO]: {
    name: 'Hydro',
    icon: NecsPDHydroIcon,
    color: '#61D1FD',
  },
  [EProductionTechnology.SOLAR]: {
    name: 'Solar',
    icon: NecsPDSolarIcon,
    color: '#F3FF0A',
  },
  [EProductionTechnology.THERMAL]: {
    name: 'Thermal',
    icon: NecsPDThermalIcon,
    color: '#C3E17E',
  },
  [EProductionTechnology.NUCLEAR]: {
    name: 'Nuclear',
    icon: NecsPDNuclearIcon,
    color: '#FF8A14',
  },
  [EProductionTechnology.MARINE]: {
    name: 'Marine',
    icon: NecsPDMarineIcon,
    color: '#A0FFE4',
  },
  [EProductionTechnology.OTHER]: {
    name: 'Other',
    icon: NecsPDOtherIcon,
    color: '#FAFBD1',
  },
};

export const EEACountries = [
  { name: 'Austria', code: 'AT' },
  { name: 'Belgium', code: 'BE' },
  { name: 'Bulgaria', code: 'BG' },
  { name: 'Croatia', code: 'HR' },
  { name: 'Cyprus', code: 'CY' },
  { name: 'Czechia', code: 'CZ' },
  { name: 'Denmark', code: 'DK' },
  { name: 'Estonia', code: 'EE' },
  { name: 'Finland', code: 'FI' },
  { name: 'France', code: 'FR' },
  { name: 'Germany', code: 'DE' },
  { name: 'Greece', code: 'EL' },
  { name: 'Hungary', code: 'HU' },
  { name: 'Iceland', code: 'IS' },
  { name: 'Ireland', code: 'IE' },
  { name: 'Italy', code: 'IT' },
  { name: 'Latvia', code: 'LV' },
  { name: 'Liechtenstein', code: 'LI' },
  { name: 'Lithuania', code: 'LT' },
  { name: 'Luxembourg', code: 'LU' },
  { name: 'Malta', code: 'MT' },
  { name: 'Netherlands', code: 'NL' },
  { name: 'Norway', code: 'NO' },
  { name: 'Poland', code: 'PL' },
  { name: 'Portugal', code: 'PT' },
  { name: 'Romania', code: 'RO' },
  { name: 'Slovakia', code: 'SK' },
  { name: 'Slovenia', code: 'SI' },
  { name: 'Spain', code: 'ES' },
  { name: 'Sweden', code: 'SE' },
];

export const EecsDeliveryTypeMap = {
  [ECertificateType.SPOT]: {
    name: 'Spot',
    tooltip: '',
    styles: 'bg-appSpotColor',
  },
  [ECertificateType.FORWARD]: {
    name: 'Forward',
    tooltip: '',
    styles: 'bg-appForwardColor',
  },
};

export const productionYearOptions = Array.from({ length: 7 }, (_, index) => {
  const year = new Date().getFullYear() - 1 + index;
  return {
    id: `${year}`,
    label: `${year}`,
    name: `${year}`,
    value: `${year}`,
  };
});

export const MIN_EXPIRATION_DATE_FOR_ASSIGNMENT = 1;
